/**
 * This theme declaration is in align with the Tailwind theme config
 */
module.exports = {
  fontFamily: {
    display: ['Raleway', 'sans-serif'],
    body: ['Raleway', 'sans-serif'],
  },
  screens: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    xxl: '1560px',
  },
  extend: {
    transitionProperty: {
      maxHeight: 'max-height',
      spacing: 'margin, padding',
      backgroundImage: 'background',
      position: 'top, left, right, bottom',
      fontSize: 'font-size',
    },
    spacing: {
      rem375: '.375rem',
      facilityLg: '23px',
      '3px': '3px',
      '15px': '15px',
      '15vh': '15vh',
      11: '2.75rem',
      13: '3.25rem',
      14: '3.5rem',
      15: '3.75rem',
      18: '4.5rem',
      19: '4.75rem',
      22: '5.5rem',
      28: '7rem',
      40: '10rem',
      58: '14.5rem',
      68: '17rem',
      70: '17.5rem',
      72: '18rem',
      78: '20rem',
      80: '20.5rem',
      82: '21rem',
      '1/2': '50%',
      '1/3': '33.33%',
      '1/4': '25%',
    },
    height: {
      '20px': '20px',
      '45px': '45px',
      '60px': '60px',
      'vw-25': '25vw',
      'vw-10': '10vw',
      'screen-60': '60vh',
      'screen-90': '90vh',
      facilitySm: '85px',
      facilityMd: '105px',
      facilityLg: '140px',
      facilityXxl: '165px',
      '98per': '98%',
    },
    width: {
      '20px': '20px',
      '45px': '45px',
      '60px': '60px',
      '1/8': '12.5%',
      '300px': '300px',
      inherit: 'inherit',
      facilitySm: '85px',
      facilityMd: '105px',
      facilityLg: '135px',
      facilityXxl: '169.5px',
      '96Per': '96%',
    },
    minWidth: {
      '20px': '20px',
      200: '200px',
      180: '180px',
      330: '330px',
    },
    minHeight: {
      errorContainerLg: 'calc(100vh - 25rem)',
      serviceCardLg: '490px',
      serviceCardSm: '388px',
    },
    fontSize: {
      tiny: '.75rem',
      base: ['1rem', '1.75rem'],
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
      '3xl': '1.75rem',
      '4xl': '2.25rem',
      '5xl': '3rem',
      '6xl': '7.5rem',
      50: '12.5rem',
    },
    lineHeight: {
      32: '8rem',
      52: '13rem',
    },
    opacity: { 80: '0.80', 60: '0.60', 10: '0.10' },
    maxHeight: {
      100: '100px',
      110: '110px',
      150: '150px',
      180: '180px',
      200: '200px',
      400: '400px',
      600: '600px',
      800: '800px',
      900: '900px',
      1000: '1000px',
    },
    borderRadius: {
      lgPlus: '.625rem',
      base: '16px',
      100: '100px',
      '2xl': '1rem',
      '3xl': '1.5rem',
    },
    boxShadow: {
      primary: '0 5px 10px rgba(0, 0, 0, .25)',
      secondary: '0 4px 10px rgba(0, 0, 0, .2)',
      big: '0 30px 40px rgba(32, 39, 54, .02)',
    },
    borderWidth: {
      3: '3px',
    },
    colors: {
      black: '#000',
      white: '#fff',
      hoverShade: 'rgba(0, 0, 0, .25)',
      bgShade: 'rgba(0, 0, 0, .4)',
      primary: {
        300: '#fbe6f3',
        400: '#ef9dd1',
        500: '#d70b8c',
        default: '#d70b8c',
        600: '#ac0870',
      },
      secondary: {
        300: '#dff3f7',
        400: '#a0dbe8',
        500: '#009bb3',
        default: '#009bb3',
        600: '#00829e',
      },
      basic: {
        100: '#fff',
        200: '#f2f2f2',
        300: '#e5e5e5',
        400: '#ccc',
        500: '#999',
        600: '#666',
        700: '#323232',
        800: '#000',
        900: '#c4c4c4',
      },
      notification: {
        success: '#8cc63f',
        warning: '#f7931e',
        error: '#ed1651',
        wagtail: '#007d7e',
      },
      'activity-sport': {
        400: '#eff9fb',
        500: '#2db6c9',
        default: '#2db6c9',
      },
      'activity-relax': {
        400: '#eaedf8',
        500: '#364cbe',
        default: '#364cbe',
      },
      'activity-learn': {
        400: '#f1ebf4',
        500: '#793795',
        default: '#793795',
      },
      'activity-outing': {
        400: '#f8eaf9',
        500: '#bb35c6',
        default: '#bb35c6',
      },
    },
    zIndex: {
      '-10': '-10',
      100: '100',
      110: '110',
      120: '120',
      130: '130',
      140: '140',
      150: '150',
    },
    flex: {
      '1/12': '0 0 8.3333%',
      '1/8': '0 0 12.5%',
      '1/6': '0 0 16.6666%',
      '1/4': '0 0 25%',
      '1/3': '0 0 33.3333%',
      '1/2': '0 0 50%',
      '7/12': '0 0 58.3333%',
      '2/3': '0 0 66.6666%',
      '3/4': '0 0 75%',
      full: '0 0 100%',
    },
    maxWidth: {
      '1/12': '8.3333%',
      '1/8': '12.5%',
      '1/6': '16.6666%',
      '1/4': '25%',
      '1/3': '33.3333%',
      '1/2': '50%',
      '7/12': '58.3333%',
      '2/3': '66.6666%',
      '3/4': '75%',
      '10/12': '83.333333%',
      '11/12': '91.666667%;',
    },
    inset: {
      unset: 'unset',
      250: '250px',
      350: '350px',
      550: '550px',
      '1/2': '50%',
      '1/3': '33.33%',
      '1/4': '25%',
      15: '15px',
      20: '20px',
    },
  },
};
